var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52698 18.9003C14.7186 18.9003 18.9272 14.6916 18.9272 9.5C18.9272 4.30837 14.7186 0.0997314 9.52698 0.0997314C4.33535 0.0997314 0.126709 4.30837 0.126709 9.5C0.126709 14.6916 4.33535 18.9003 9.52698 18.9003ZM15.6427 8.39792C15.9462 8.70143 16.0924 9.10265 16.0814 9.50033C16.0923 9.89779 15.946 10.2987 15.6427 10.6021L11.4 14.8447C10.8142 15.4305 9.86448 15.4305 9.27869 14.8447C8.69291 14.2589 8.69291 13.3092 9.27869 12.7234L11.0021 11H3.85071C3.02228 11 2.35071 10.3284 2.35071 9.5C2.35071 8.67157 3.02228 7.99999 3.85071 7.99999L11.0021 8L9.27871 6.2766C8.69292 5.69082 8.69292 4.74107 9.27871 4.15528C9.8645 3.5695 10.8142 3.5695 11.4 4.15528L15.6427 8.39792Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/Switch.762b171d7910ea36d469f21c945f41bc.svg";
export { ForwardRef as ReactComponent };